module.exports = __webpack_public_path__ + "ccc45effefdfed76c62cbac475d8f2f0.pdf";